import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite';
import qs from 'qs';

import styles from './styles.js';

import {
    fetchActions,
    filterActions,
    verticalActions
} from '../../../pages/Search/actions';

import SearchBar from './SearchBar';
import HorizontalTabs from './HorizontalTabs';

class MoveableDiv extends Component {
    static propTypes = {
        activeVerticalId: PropTypes.number.isRequired,
        apiUrl: PropTypes.string.isRequired,
        changeVertical: PropTypes.func.isRequired,
        domain: PropTypes.string.isRequired,
        trackingCookieId: PropTypes.number.isRequired,
        userLang: PropTypes.string.isRequired,
        verticals: PropTypes.array.isRequired
    }

    changeVertical = event => {
        const { apiUrl, changeVertical, trackingCookieId, userLang, verticals } = this.props;
        const location = decodeURIComponent(window.location.pathname.split('/')[4]);
        const originalRequestParams = window.location.search.split('?')[1];
        const parsedRequestParams = qs.parse(originalRequestParams);
        // const persistentParams = {
        //     location: parsedRequestParams.location,
        //     date: parsedRequestParams.date,
        //     guests: parsedRequestParams.guests
        // };
        delete parsedRequestParams.page;
        const verticalId = event.target.dataset.verticalId;
        const upcomingVertical = verticals.find(
            vert => Number(vert.id) === Number(verticalId)
        );
        const tag = {
            quick_slug: upcomingVertical.slug
        };
        // let newRequestParams;
        // if (upcomingVertical.lastParams) {
        //     newRequestParams = `${
        //         qs.stringify(persistentParams, { arrayFormat: 'brackets' })
        //     }&${
        //         qs.stringify(upcomingVertical.lastParams, { arrayFormat: 'brackets' })
        //     }`;
        // } else {
        //     newRequestParams = originalRequestParams;
        // }

        changeVertical(
            apiUrl,
            userLang,
            location,
            tag,
            qs.stringify(parsedRequestParams, { arrayFormat: 'brackets' }),
            // newRequestParams,
            verticalId,
            trackingCookieId
        );
    }

    render() {
        const { changeVertical } = this;
        const { activeVerticalId, domain, verticals } = this.props;
        const tabItemsArray = verticals.map(vertical => ({
            id: vertical.id,
            title: vertical.title,
            slug: vertical.slug
        }));
        return (
            <div className={css(styles.moveableDivWithTabs)}>
                <div className={css(styles.searchBarWrapper)}>
                    <SearchBar domain={domain} />
                </div>
                <div className={css(styles.horizontalNavWrapper)}>
                    <HorizontalTabs
                        activeVerticalId={activeVerticalId}
                        clickAction={changeVertical}
                        tabItems={tabItemsArray}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    activeVerticalId: state.activeVerticalId,
    apiUrl: state.config.apiUrl,
    trackingCookieId: state.config.trackingCookieId,
    userLang: state.config.userLang,
    verticals: state.verticals
});

const mapDispatchToProps = dispatch => {
    return {
        changeVertical: (
            apiUrl,
            userLang,
            location,
            tag,
            originalRequestParams,
            // newRequestParams,
            verticalId,
            trackingCookieId,
        ) => {
            dispatch(
                fetchActions.fetchSearchResults(
                    apiUrl,
                    userLang,
                    location,
                    tag,
                    originalRequestParams,
                    // newRequestParams,
                    trackingCookieId,
                    true
                )
            );
            dispatch(verticalActions.changeVertical(verticalId));
            dispatch(filterActions.setTagLabel(''));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MoveableDiv);



// WEBPACK FOOTER //
// ./src/components/Header/MoveableDiv/MoveableDiv.jsx